module.exports = __webpack_public_path__ + "06beadadacfea8f41116d0abdb9600eb.svg";